import {BrowserModule} from '@angular/platform-browser';
import {NgModule, APP_INITIALIZER} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';

import {AppComponent} from './app.component';
import {HeaderComponent} from './header/header.component';
import {NotFoundComponent} from './not-found/not-found.component';
import {rootRouting} from "./app.routing";
import {HomeComponent} from './home/home.component';
import {NotificationsComponent} from './notifications/notifications.component';
import {SignInComponent} from './signin/signin.component';
import {SignOutComponent} from './signout/signout.component';
import {AppConfig} from "./app.config";
import {ServerErrorComponent} from './server-error/server-error.component';
import {PaginationComponent} from './pagination/pagination.component';
import { PaginationService }      from './pagination2/pagination.service';
import { PaginationComponent2 }      from './pagination2/pagination.component';
import {LoaderComponent} from "./loader/loader.component";
import {HttpClient} from "./http.client";
import {Auth} from "./app.auth";
import {AuthService} from "./auth.service";
import {UserService} from "./users/user.service";
import {UsersComponent} from "./users/users.component";
import {CommonModule} from "@angular/common";
import {AuthenticationGuard} from "./guards/authentication.guard";
import {CountryService} from "./country.service";
import {Ng2Bs3ModalModule} from "ng2-bs3-modal/ng2-bs3-modal";
import {NotificationService} from "./notifications/notification.service";
import { CollectionComponent } from './collection/collection.component';
import {SelectModule} from 'ng2-select';
import { JewlaryComponent } from './jewlary/jewlary.component';
import { EqualValidator }           from './equal-validator.directive';
import { Ng2TelInput }              from './ng2-intl-tel-input';
import {PopoverModule} from 'ng2-popover';
import {MyDatePickerModule} from 'mydatepicker';

export function configServiceFactory(config: AppConfig) {
    return function () {
        return config.load();
    }
}

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        HttpModule,
        Ng2Bs3ModalModule,
        SelectModule,
        PopoverModule,
        MyDatePickerModule,
        rootRouting
    ],
    declarations: [
        LoaderComponent,
        AppComponent,
        HeaderComponent,
        NotFoundComponent,
        HomeComponent,
        NotificationsComponent,
        SignInComponent,
        SignOutComponent,
        EqualValidator,
        Ng2TelInput,
        ServerErrorComponent,
        PaginationComponent,
        PaginationComponent2,
        UsersComponent,
        CollectionComponent,
        JewlaryComponent
    ],
    providers: [
        AppConfig,
        AuthenticationGuard,
        PaginationService,
        Auth,
        AuthService,
        UserService,
        NotificationService,
        CountryService,
        HttpClient,
        {provide: APP_INITIALIZER, useFactory: configServiceFactory, deps: [AppConfig], multi: true}
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts